import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from './../../service';

import { Observable } from 'rxjs/Observable';
import { timeout } from 'rxjs/operators';

import { Logger } from './../../logger/logger.service';
const log = new Logger('@mycure/mc-services');

export interface SyncbaseConfig {
  accountsUrl: string;
  accountsPort: string;
  serverUrl: string;
  serverPort: string;
}

@Injectable({
  providedIn: 'root'
})

export class McSyncbaseConnectionService {

  constructor(
    private sdk: MycureSDK,
    private http: HttpClient,
  ) {

  }

  /**
   * Store Syncbase Connection
   * @param ip 
   * @param port 
   * @param accountUrl 
   * @param accountPort
   */
  storeConfig(config: SyncbaseConfig): Observable<any> {
    if (!config.serverUrl || !config.serverPort || !config.accountsUrl || !config.accountsPort) {
      throw new Error('missing configs');
    }

    const uri: string = `${config.serverUrl}:${config.serverPort}`;
    const params = { id: 'country-phl' };
    return this.http.get(`http://${uri}/fixtures`, { params }).pipe(timeout(3000));
  }

  storeSyncbaseConfig(config: any) {
    if (!config.serverUrl || !config.serverPort || !config.accountsUrl || !config.accountsPort) {
      throw new Error('missing configs');
    }

    const uri: string = `http://${config.serverUrl}:${config.serverPort}`;
    const accountUri: string = `http://${config.accountsUrl}:${config.accountsPort}`;

    // store synchbase configs
    localStorage.setItem('syncbase:uri', uri);
    localStorage.setItem('syncbase:account', accountUri);
  }

  restoreSyncbaseConfig(uri: string, accountUri: string) {
    // store synchbase configs
    localStorage.setItem('syncbase:uri', uri);
    localStorage.setItem('syncbase:account', accountUri);
  }

  removeConfig() {
    localStorage.removeItem('syncbase:uri');
    localStorage.removeItem('syncbase:account');
  }

  /**
   * Load Syncbase Config
   */
  loadConfig(): any {
    const uri = localStorage.getItem('syncbase:uri');
    const account = localStorage.getItem('syncbase:account');

    // if has saved values, return as item
    if (uri && account) return { uri, account };

    return undefined;
  }

  /**
   * Assertion for syncbase config if there's any
   */
  modifySdkConfigs() {
    const syncbaseConfig = this.loadConfig();
    if (!syncbaseConfig || !syncbaseConfig.uri) return;

    // if has sync base configs
    this.sdk.initialize(syncbaseConfig.uri);
  }
}
